export default __webpack_public_path__ + "static/media/satellite-icon.5bf24e9d.svg";